import { useNavigate } from 'react-router-dom'

type TabId = 'dashboard' | 'students' | 'attendance' | 'homework' | 'more'

const tabs: { id: TabId; label: string; icon: string; path: string }[] = [
  { id: 'dashboard', label: 'หน้าหลัก', icon: '🏠', path: '/dashboard' },
  { id: 'students', label: 'นักเรียน', icon: '👩‍🎓', path: '/students' },
  { id: 'attendance', label: 'เช็คชื่อ', icon: '📋', path: '/attendance' },
  { id: 'homework', label: 'การบ้าน', icon: '📝', path: '/homework' },
  { id: 'more', label: 'เพิ่มเติม', icon: '⚙️', path: '/settings' },
]

export function BottomTabBar({ active }: { active: TabId }) {
  const navigate = useNavigate()

  return (
    <nav className="fixed bottom-0 left-0 right-0 border-t border-gray-200 bg-white pb-safe-bottom">
      <div className="mx-auto flex max-w-lg justify-around">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`flex flex-1 flex-col items-center py-2 text-xs ${
              active === tab.id ? 'font-semibold text-primary-600' : 'text-gray-400'
            }`}
          >
            <span className="text-lg">{tab.icon}</span>
            <span className="mt-0.5">{tab.label}</span>
          </button>
        ))}
      </div>
    </nav>
  )
}
